/**
 * Which organization the portal is currently working in.
 *
 * The API layer needs this outside React: the fetch wrapper in
 * runtime-config.ts adds `X-Organization-Id` to every portal request, and it
 * runs far away from any component. So the value lives here, in the same
 * shape as the token store next door, and AuthProvider keeps it in step with
 * the signed-in person.
 *
 * It is a convenience, not a permission. The backend reads the header, checks
 * it against the caller's own memberships, and answers not-found for one they
 * do not belong to - so setting this to somebody else's organization buys
 * nothing.
 *
 * Kept in sessionStorage rather than localStorage, and alongside the tokens,
 * so closing the tab ends the choice along with the session.
 */
const KEY = 'activistarc.portal.organization';

export const organizationScope = {
  get(): string | null {
    try {
      return sessionStorage.getItem(KEY);
    } catch {
      // Private windows and blocked site data both throw here. The header is
      // then simply absent, which is correct for anybody who belongs to one
      // organization and an honest 400 for anybody who belongs to several.
      return null;
    }
  },

  set(organizationId: string | null): void {
    try {
      if (organizationId) sessionStorage.setItem(KEY, organizationId);
      else sessionStorage.removeItem(KEY);
    } catch {
      // Nothing to do. See get().
    }
  },

  clear(): void {
    this.set(null);
  },
};
